import { SvgIcon, SvgIconProps } from "@mui/material";

const IncreaseResIcon = (props: SvgIconProps) => {
	return (
		<SvgIcon viewBox="0 0 17 17" {...props}>
			<path
				d="M8.29175 0.625H15.6251V7.95833"
				stroke="var(--black-color)"
				strokeOpacity="0.85"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
				fill="none"
			/>
			<path
				d="M7.95825 15.625L0.624918 15.625L0.624919 8.29167"
				stroke="var(--black-color)"
				strokeOpacity="0.85"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
				fill="none"
			/>
			<rect
				x="3.625"
				y="3.625"
				width="9"
				height="9"
				stroke="var(--black-color)"
				strokeOpacity="0.85"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
				fill="none"
			/>
		</SvgIcon>
	);
};

export default IncreaseResIcon;
